import './style.scss';

import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

// eslint-disable-next-line no-unused-vars
const mvSlide = new Swiper('.mv-slider', {
  autoplay: {
    delay: 6000,
  },
  loop: true,
  speed: 800,
  spaceBetween: 5,
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  observer: true,
  observeParents: true,
});